import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function getStyle(progress) {
  if (progress === null) {
    return {};
  }
  return {
    width: `${progress * 100}%`,
  };
}

const ProgressBar = ({progress}) => (
  <div
    className={classNames('ProgressBar', {
      'ProgressBar--indeterminate': progress === null,
    })}
  >
    <div className="ProgressBar__meter">
      <span
        className="ProgressBar__fill"
        style={getStyle(progress)}
      />
    </div>
  </div>
);

ProgressBar.propTypes = {
  progress: PropTypes.number,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js